import { EnvironmentOutlined } from '@ant-design/icons';
import type { BasicDataNode, DataNode } from 'antd/es/tree';
import type { Key } from 'react';
import { useCallback, useMemo } from 'react';

import * as Styled from './styles';
import type { Props } from './types';

const RegionTree = ({ options, value, searchValue, onChange }: Props) => {
  const { optionByKey, treeData } = useMemo(() => {
    const normalizedSearch = searchValue.trim().toLocaleLowerCase();
    const filteredOptions = options.filter(option =>
      option.label.toLocaleLowerCase().includes(normalizedSearch)
    );

    return {
      optionByKey: new Map(
        filteredOptions.map(option => [option.value, option])
      ),
      treeData: filteredOptions.map(option => ({
        key: option.value,
        title: option.label
      }))
    };
  }, [options, searchValue]);

  const renderTitle = useCallback(
    (node: BasicDataNode | DataNode) => {
      const nodeKey = 'key' in node ? String(node.key) : '';
      const option = optionByKey.get(nodeKey);

      if (!option) {
        return null;
      }

      return (
        <Styled.RegionItem>
          <Styled.RegionIcon>
            <EnvironmentOutlined />
          </Styled.RegionIcon>

          {option.label}

          {option.value === value && (
            <Styled.CurrentRegion>YOU'RE HERE</Styled.CurrentRegion>
          )}
        </Styled.RegionItem>
      );
    },
    [optionByKey, value]
  );
  const handleSelect = useCallback(
    (selectedKeys: Key[]) => {
      const selectedRegion = selectedKeys[0];

      if (typeof selectedRegion === 'string') {
        onChange(selectedRegion);
      }
    },
    [onChange]
  );

  if (!treeData.length) {
    return <Styled.NoResults>No results found</Styled.NoResults>;
  }

  return (
    <Styled.RegionTree
      treeData={treeData}
      selectable
      selectedKeys={[]}
      checkable={false}
      showLine={false}
      titleRender={renderTitle}
      onSelect={handleSelect}
    />
  );
};

export default RegionTree;
